import React from 'react';
import SprintIcon from '@atlaskit/icon/core/migration/sprint';
import { N300 } from '@atlaskit/theme/colors';
import { token } from '@atlaskit/tokens';
import LegendItem from '@atlassian/jira-aais-timeline-legend/src/ui/legend-item/index.tsx';
import LegendSection from '@atlassian/jira-aais-timeline-legend/src/ui/legend-section/index.tsx';
import LegendComponent from '@atlassian/jira-aais-timeline-legend/src/ui/legend/index.tsx';
import DependenciesIcon from '@atlassian/jira-aais-timeline-legend/src/ui/symbols/dependencies-icon/index.tsx';
import IssueBarIcon from '@atlassian/jira-aais-timeline-legend/src/ui/symbols/issue-bar-icon/index.tsx';
import ReleaseStatusIcon from '@atlassian/jira-aais-timeline-legend/src/ui/symbols/release-status-icon/index.tsx';
import RollupIcon from '@atlassian/jira-aais-timeline-legend/src/ui/symbols/rollup-icon/index.tsx';
import { useIntl } from '@atlassian/jira-intl';
import messages from './messages';

const Legend = () => {
	const { formatMessage } = useIntl();

	const sprintsMessage = formatMessage(messages.sprints);
	const dependencyMessage = formatMessage(messages.dependency);
	const rollupMessage = formatMessage(messages.rollup);

	const noEndDateMessage = formatMessage(messages.noEndDate);
	const noStartDateMessage = formatMessage(messages.noStartDate);

	const releasedMessage = formatMessage(messages.released);
	const unreleasedMessage = formatMessage(messages.unreleased);
	const overdueMessage = formatMessage(messages.overdue);

	return (
		<LegendComponent>
			<LegendSection title={formatMessage(messages.general)}>
				<LegendItem
					symbol={
						<SprintIcon
							LEGACY_size="medium"
							label={sprintsMessage}
							color={token('color.text.subtle', N300)}
							spacing="spacious"
						/>
					}
					label={sprintsMessage}
				/>
				<LegendItem
					symbol={<DependenciesIcon label={dependencyMessage} />}
					label={dependencyMessage}
				/>
				<LegendItem symbol={<RollupIcon label={rollupMessage} />} label={rollupMessage} />
			</LegendSection>

			<LegendSection title={formatMessage(messages.issueBars)}>
				<LegendItem symbol={<IssueBarIcon type="noEndDate" />} label={noEndDateMessage} />
				<LegendItem symbol={<IssueBarIcon type="noStartDate" />} label={noStartDateMessage} />
			</LegendSection>

			<LegendSection title={formatMessage(messages.releases)}>
				<LegendItem symbol={<ReleaseStatusIcon type="released" />} label={releasedMessage} />
				<LegendItem symbol={<ReleaseStatusIcon type="unreleased" />} label={unreleasedMessage} />
				<LegendItem symbol={<ReleaseStatusIcon type="overdue" />} label={overdueMessage} />
			</LegendSection>
		</LegendComponent>
	);
};

export default Legend;
